import { graphql } from "gql.tada";
import { ThemeFragment } from "./fragments/ThemeFragment";
import { MetadataFragment } from "./fragments/MetadataFragment";

export const GetPageBySlug = graphql(
  /* GraphQL */ `
    query GetPageBySlug($locale: String, $preview: Boolean, $slug: String) {
      pageCollection(
        locale: $locale
        preview: $preview
        where: { slug: $slug }
        limit: 1
      ) {
        items {
          __typename
          title
          slug
          metadata {
            ...MetadataFragment
          }
          theme {
            ...ThemeFragment
          }
          hero {
            ...EntryFragment
          }
          blocksCollection {
            items {
              ...EntryFragment
            }
          }
          navigationAccessibilityLabel
        }
      }
    }

    fragment EntryFragment on Entry {
      __typename
      sys {
        id
      }
    }
  `,
  [ThemeFragment, MetadataFragment]
);
